import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import useStyles from './DashboardCardActionsStyle.js';

export default function DashboardCardActions(props) {
  const uiClasses = useStyles();

  const buttons = props.editMode
    ? <>
      <IconButton
        disabled={!props.isFormValid}
        onClick={() => props.onSave()}
      >
        <CheckIcon />
      </IconButton>

      <IconButton
        onClick={() => props.onCancel()}
      >
        <CloseIcon />
      </IconButton>
    </> : <>
      <IconButton
        onClick={() => props.onEdit()}
      >
        <EditIcon />
      </IconButton>

      <IconButton
        onClick={() => props.onDelete()}
      >
        <DeleteIcon />
      </IconButton>
    </>

  return (
    <div className={uiClasses.root}>
      {buttons}
    </div>
  );
};
